import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL ?? 'http://localhost:5126';

const STATUTS = ['En attente', 'Confirmé', 'Annulé'];

const STATUT_STYLE = {
  'En attente': { background: '#fef3c7', color: '#92400e' },
  'Confirmé':   { background: '#dcfce7', color: '#166534' },
  'Annulé':     { background: '#fee2e2', color: '#991b1b' },
};

const formatDate = (dateStr) => {
  const [y, m, d] = dateStr.split('-');
  return new Date(y, m - 1, d).toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
};

const AdminRdv = () => {
  const [rdvs, setRdvs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [confirmDelete, setConfirmDelete] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/rdv`);
      setRdvs(data);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const handleStatut = async (id, statut) => {
    await axios.patch(`${API}/rdv/${id}/statut`, { statut });
    setRdvs(prev => prev.map(r => r.id === id ? { ...r, statut } : r));
  };

  const handleDelete = async (id) => {
    await axios.delete(`${API}/rdv/${id}`);
    setRdvs(prev => prev.filter(r => r.id !== id));
    setConfirmDelete(null);
  };

  const enAttente = rdvs.filter(r => r.statut === 'En attente').length;

  if (loading) return <div className="admin-spinner">Chargement...</div>;

  return (
    <>
      <div className="admin-page-title">
        Rendez-vous
        {enAttente > 0 && <span style={{ marginLeft: 12, background: '#fef3c7', color: '#92400e', fontSize: '0.75rem', fontWeight: 700, padding: '2px 10px', borderRadius: 20 }}>{enAttente} en attente</span>}
      </div>
      <div className="admin-page-sub">Gérez les demandes de rendez-vous.</div>

      {rdvs.length === 0 ? (
        <div className="admin-empty">Aucun rendez-vous pour le moment.</div>
      ) : (
        <div className="admin-card" style={{ padding: 0, overflow: 'hidden' }}>
          <table className="admin-table">
            <thead>
              <tr>
                <th>Date / Heure</th>
                <th>Client</th>
                <th>Service</th>
                <th>Contact</th>
                <th>Statut</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {rdvs.map(r => (
                <tr key={r.id}>
                  <td>
                    <div style={{ fontWeight: 700 }}>{formatDate(r.date)}</div>
                    <div style={{ color: '#16a34a', fontWeight: 600, fontSize: '0.9rem' }}>{r.heure}</div>
                  </td>
                  <td>
                    <div style={{ fontWeight: 600 }}>{r.prenom} {r.nom}</div>
                  </td>
                  <td>
                    <span className="admin-badge">{r.service}</span>
                  </td>
                  <td>
                    <div style={{ fontSize: '0.85rem' }}>
                      <a href={`tel:${r.telephone}`} style={{ color: '#16a34a', display: 'block' }}>{r.telephone}</a>
                      <a href={`mailto:${r.email}`} style={{ color: '#6b7280', fontSize: '0.8rem' }}>{r.email}</a>
                    </div>
                  </td>
                  <td>
                    <select
                      value={r.statut}
                      onChange={e => handleStatut(r.id, e.target.value)}
                      style={{ ...STATUT_STYLE[r.statut], border: 'none', borderRadius: 20, padding: '4px 10px', fontSize: '0.8rem', fontWeight: 700, cursor: 'pointer' }}
                    >
                      {STATUTS.map(s => <option key={s} value={s}>{s}</option>)}
                    </select>
                  </td>
                  <td>
                    <button className="admin-btn-icon danger" onClick={() => setConfirmDelete(r)} title="Supprimer">🗑</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {confirmDelete && (
        <div className="admin-modal-overlay" onClick={() => setConfirmDelete(null)}>
          <div className="admin-modal" style={{ maxWidth: 400 }} onClick={e => e.stopPropagation()}>
            <div className="admin-modal-header">
              <div className="admin-modal-title">Supprimer ce rendez-vous ?</div>
              <button className="admin-modal-close" onClick={() => setConfirmDelete(null)}>✕</button>
            </div>
            <div className="admin-modal-body">
              <p style={{ color: '#374151', fontSize: '0.9rem' }}>
                {confirmDelete.prenom} {confirmDelete.nom} — {formatDate(confirmDelete.date)} à {confirmDelete.heure}
              </p>
            </div>
            <div className="admin-modal-footer">
              <button className="admin-btn admin-btn-secondary" onClick={() => setConfirmDelete(null)}>Annuler</button>
              <button className="admin-btn admin-btn-danger" onClick={() => handleDelete(confirmDelete.id)}>Supprimer</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AdminRdv;
